import { notificationsReducer } from './../components/Notification/notification-reducer';
import { newAccountReducer } from './../components/Accounts/New account/newAccount-reducer';
import { usersReducer } from './../components/Users/users-reducer';
import { newTaskAttachmentsReducer } from './../components/NewTask/newTaskAttachments-reducer';
import { authReducer } from './../components/Login/auth-reducer';
import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
//import { tasksReducer } from "../components/Projects/tasks-reducer";
import { projectsReducer } from "../components/Projects/project-reducer";
import { appReducer } from "./app-reducer";
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { workItemsReducer } from '../components/TasksList/tasks-reducer';
import { newTaskReducer } from '../components/NewTask/newTask-reducer';
import { commentsReducer } from '../components/Task/Comments/comments-reducer';
import { accountsReducer } from '../components/Accounts/accounts-reducer';
import { commentsAppReducer } from '../components/Task/Comments/commentsApp-reducer';


const rootReducer = combineReducers({
  projects: projectsReducer,
  workItems: workItemsReducer,
  app: appReducer,
  commentApp: commentsAppReducer,
  auth: authReducer,
  newTask: newTaskReducer,
  newTaskAttachments: newTaskAttachmentsReducer,
  commentsTaskPart: commentsReducer,
  accounts: accountsReducer,
  users: usersReducer,
  newAccount: newAccountReducer,
  notification: notificationsReducer
})

export type AppRootState = ReturnType<typeof rootReducer>
// 
// export const store = createStore(rootReducer, applyMiddleware(thunk))

export const store = configureStore({
   reducer: rootReducer,
   middleware: getDefaultMiddleware => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
   }).prepend(thunk)
})

// @ts-ignore
window.store = store

type AppDispatchType = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatchType>()